module.exports = __webpack_public_path__ + "img/yqlogo.af3ac433.png";